import React from 'react';
import Banner from '../../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../../assets/images/satellite/banner.png";
const OutsourcingSecurityBanner = (props) => (
    <Banner
        id="outsourcing-security-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingSecurity.section-1.title"
        text="services:outsourcingSecurity.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        timeDelay={1.55}
        noText
    />
);

export default OutsourcingSecurityBanner;
